module.exports = __webpack_public_path__ + "img/biaoqian_tianranshuiyuan.6400f454.png";